import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/hooks';
import { analyticsService } from '@/services';
import { ANALYTICS_CONFIG } from '@/constants/analytics';
import { logger } from '@/lib/logger';

export const useAnalytics = () => {
  const location = useLocation();
  const user = useAppSelector((state) => state.auth.user);
  const currentStoreId = useAppSelector((state) => state.stores?.currentStoreId);
  const [isAnalyticsReady, setIsAnalyticsReady] = useState(false);

  useEffect(() => {
    try {
      // Only initialize if analytics is enabled
      if (ANALYTICS_CONFIG.ENABLED) {
        analyticsService.init(ANALYTICS_CONFIG.MEASUREMENT_ID);
      }
      setIsAnalyticsReady(true);
    } catch (error) {
      logger.warn('Analytics initialization failed', { error, component: 'useAnalytics' });
      setIsAnalyticsReady(true); // Still mark as ready to not block app
    }
  }, []);

  useEffect(() => {
    try {
      // Only track page views if analytics is enabled
      if (ANALYTICS_CONFIG.ENABLED) {
        analyticsService.trackPageView(`${window.location.origin}${location.pathname}`, {
          userId: user?.id || '',
          storeId: currentStoreId || '',
        });
      }
    } catch (error) {
      logger.warn('Analytics tracking failed', { error, component: 'useAnalytics' });
    }
  }, [location, user, currentStoreId]);

  return { isAnalyticsReady, analyticsService };
}; 